var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtistproofsicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 28,
    height: 28,
    stroke: "black",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    width: 28,
    height: 8,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 34,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 34,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 34,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 34,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 34,
    width: 3,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 34,
    width: 1,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistproofsicon);
export default __webpack_public_path__ + "static/media/artistproofsicon.c2de6daf04818fb54f2171a8b81d68bd.svg";
export { ForwardRef as ReactComponent };